'use strict';

var react = require('react');

function useMountedState() {
    const mountedReference = react.useRef(false);
    react.useEffect(() => {
        mountedReference.current = true;
        return () => {
            mountedReference.current = false;
        };
    }, []);
    const isMounted = react.useCallback(() => mountedReference.current, []);
    return isMounted;
}

exports.useMountedState = useMountedState;
//# sourceMappingURL=useMountedState.js.map
